// import { useContext } from "react";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import Featured from "../Components/Skills/Featured";
import QuickCopeImage from "../Media/QuickCopeImage.svg";
// import { useFetchAPIContext } from "../context/FetchAPIContext";
// import useFetchAPI from "../Components/Hooks/useFetchAPI";
// import { API } from "../constant";

const QuickCope = () =>{
    // const data = useFetchAPI(`${API}/app-information?populate=*`);
    // console.log(data);
    return(
        <div className="activities quick-cope">   
            <div className="container">
                <Header title ="Quick Cope"/>
                <div className="content-wrap bg-gradient-light">
                    <div className="activity-img mb---30"> 
                    <div className="description fade-in-down delay-3">
                        <h2 className="title mt---0 mb---20">Quick Cope</h2>
                        <h4 className="sub-title mt---0 mb---10">Use a coping skill to calm down quickly &
lower intense emotions.</h4>
                        <p className="text">These skills can lower your emotions and help you think clearly.</p>
                    </div>
                    <Featured headTitle="" desc=""/> 
                    </div>  
                </div> 
                <Footer />
            </div>
        </div>
    );
}
export default QuickCope;